module.exports = __webpack_public_path__ + "img/img_bot_letter@2x.70fb10d1.png";